export const SUMMARY_STATE = 'summary'

export const FETCH_SUMMARY_REQUEST = 'FETCH_SUMMARY_REQUEST'
export const FETCH_SUMMARY_SUCCESS = 'FETCH_SUMMARY_SUCCESS'
export const FETCH_SUMMARY_FAILURE = 'FETCH_SUMMARY_FAILURE'
